import React from 'react';

import { GenericAsyncSelect } from 'src/views/components/select';

export const createOptions = [
  { value: 'incident.trigger', label: 'Triggered' },
  { value: 'incident.acknowledge', label: 'Acknowledged' },
  { value: 'incident.unacknowledge', label: 'Unacknowledged' },
  { value: 'incident.resolve', label: 'Resolved' },
  { value: 'incident.reopen', label: 'Reopened' },
  { value: 'incident.escalate', label: 'Escalated' },
  { value: 'incident.assign', label: 'Assigned' },
  { value: 'incident.delegate', label: 'Delegated to another EP' },
  { value: 'incident.trigger_manually', label: 'Opens an issue manually' },
  { value: 'incident.priority_updated', label: 'Priority updated' },
];

export const updateOptions = [
  { value: 'incident.trigger', label: 'Triggered' },
  { value: 'incident.acknowledge', label: 'Acknowledged' },
  { value: 'incident.unacknowledge', label: 'Unacknowledged' },
  { value: 'incident.resolve', label: 'Resolved' },
  { value: 'incident.reopen', label: 'Reopened' },
  { value: 'incident.escalate', label: 'Escalated' },
  { value: 'incident.assign', label: 'Assigned' },
  { value: 'incident.delegate', label: 'Delegated to another EP' },
  { value: 'incident.priority_updated', label: 'Priority updated' },
];

const IncidentEventSelect = ({ options, ...props }) => {
  return (
    <GenericAsyncSelect
      {...props}
      valueFieldName="value"
      placeholder="Select incident action..."
      options={options || []}
    />
  );
};

export default IncidentEventSelect;
